import React, {useEffect, useRef, useState} from 'react';
import cl from "./FormCheckbox.module.css";
import {FormControlLabel, FormHelperText} from "@mui/material";
import CheckboxV2 from "../components/CheckboxV2/CheckboxV2";
import InlineTip from "../components/InlineTip";
import {inlineTipMargin} from "../AppVars";
import "./helperText.css";

const FormCheckbox = ({label, initValue, controlRef, onSelect, helperText, readOnly, tipText, style, infoText}) => {

    const inputRef = useRef(null);

    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                getChecked: () => inputRef.current.checked,
                setErrorMessage: setErrorMessage,
            };
        }
    })

    return (
        <div className={cl.main} style={style}>
            <FormControlLabel
                control={<CheckboxV2
                    iconFillColor={readOnly ? "#ffff0018" : undefined}
                    disabled={readOnly}
                    defaultChecked={initValue}
                    inputRef={inputRef}
                    onChange={e => {
                        if (errorMessage)
                            setErrorMessage("");
                        if (onSelect)
                            onSelect(e.target.checked);
                    }}
                />}
                label={
                    <div className={cl.label} style={{marginBottom: "0"}}>
                        {label}
                    </div>
                }
                disableTypography
                sx={errorMessage ? {
                    marginRight: "0",
                    border: "1px solid #d32f2f",
                    borderRadius: "4px",
                    paddingRight: "8px"
                } : {
                    marginRight: "0"
                }}
            />
            {tipText && <InlineTip text={tipText} style={{marginLeft: `${inlineTipMargin}px`, bottom: "-2px"}}/>}
            {errorMessage &&
                <FormHelperText error sx={{marginLeft: "14px", marginTop: "0px"}}>{errorMessage}</FormHelperText>}
            {helperText && <FormHelperText sx={{marginLeft: "14px", marginTop: "0px"}}>{helperText}</FormHelperText>}
            {infoText && <FormHelperText sx={{marginLeft:"14px"}} className="helperText">
                {infoText}
            </FormHelperText>}
        </div>
    );
};

export default FormCheckbox;